// extracted by mini-css-extract-plugin
var _1 = "AQJkn";
var _2 = "_HFYF";
var _3 = "Nlupn";
var _4 = "x4qLU";
var _5 = "gDU99";
var _6 = "tDJjP";
var _7 = "qXc6J";
var _8 = "EWxc9";
var _9 = "MbkIx";
export { _1 as "actionButtons", _2 as "commitMessage", _3 as "createdAt", _4 as "details", _5 as "empty", _6 as "header", _7 as "jobDetailsLink", _8 as "tagContainer", _9 as "tagDetailsContainer" }
